import { categories } from '@/mocks/superbuy';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-24 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs tracking-[0.25em] uppercase text-accent-600 font-medium mb-4 border border-accent-300/50 px-3 py-1 rounded-full">
            Categories
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            Shop By Category
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Browse our organized product collections — each category links directly to detailed product finds
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, i) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group bg-background-100 hover:bg-primary-500 rounded-2xl p-4 md:p-5 flex flex-col items-center text-center cursor-pointer transition-all duration-300 hover:-translate-y-1 ${
                i % 7 === 3 ? 'md:mt-6' : ''
              } ${i % 5 === 2 ? 'md:ml-3' : ''}`}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50 flex items-center justify-center mb-3 group-hover:bg-white/90 transition-all duration-300">
                <i className={`${cat.icon} text-primary-500 text-lg md:text-xl group-hover:text-primary-700 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors duration-300 leading-snug">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}